<template>
  <div style="width: 100%;height: 100%">
    <div>
      <img :src="globalData.user.applyBook" width="100%" height="100%" alt="">
    </div>
    <div style="text-align: center">
      <el-button type="warning" @click="checkFail">不合格</el-button>
      <el-button type="primary" @click="checkSuccess">合格</el-button>
    </div>
  </div>
</template>

<script>
let that
export default {
  data() {
    return {
      
    }
  },
  methods: {
    checkFail() {
       let user = this.globalData.user
        user.applyType = 2
        this.saveUserInfo(user)
       
      },
      checkSuccess() {
        let user = this.globalData.user
        user.applyType = 1
        this.saveUserInfo(user)
      },
      saveUserInfo(user) {
        if(user.type === 'teacher') {
          this.api.teacher.update(this.globalData.user).then(() => {
            this.$message.success("操作成功")
            this.$dialog.close('viewApplyBook')
            this.globalData.user.applyType = user.applyType == 1 ? "已通过": "未通过"
          })
        }else{
          this.api.student.update(this.globalData.user).then(res => {
            this.$message.success("操作成功")
            this.$dialog.close('viewApplyBook')
            this.globalData.user.applyType = user.applyType == 1 ? "已通过": "未通过"
          })
        }
      }
  }

}
</script>

